<template>
  <b-modal id="addCaseProblemToCaseModal" title="addCaseProblemToCaseModal" size="lg">
    <div slot="modal-header" class="w-100">
      <h5 class="modal-title float-left">
        {{$t('views.excmcase.show.addCaseProblemToCaseModal')}}
      </h5>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('addCaseProblemToCaseModal')">
        ×
      </button>
    </div>
    <create :id-case="idCase" @reload="$emit('reload')"></create>
    <div slot="modal-footer" class="w-100"></div>
  </b-modal>
</template>

<script>
import Create from '../../excmcaseproblem/CreateInModal'
export default {
  name: 'addCaseProblemToCaseModal',
  props: {
    idCase: {
      type: String,
      required: true
    }
  },

  components: { Create },
  data () {
    return {}
  }
}
</script>
